// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","logo":"Header_logo__UsziS","navLinks":"Header_navLinks__1hQOi","active":"Header_active__rHuVo","hamburger":"Header_hamburger__0Oz-R"};